import type { ParentProps } from 'solid-js'

export default function Layout(props: ParentProps) {
  return props.children
}
